// extracted by mini-css-extract-plugin
export default {"main":"Yba-z"};